import './styles/graphic.scss';
import './utils/polyfills';

import React from 'react';
import { render } from 'react-dom';
import { create } from 'jss';
import { expirationDate } from './graphic';

import { 
  ThemeProvider, 
  StylesProvider, 
  jssPreset, 
  createGenerateClassName,
} from '@material-ui/styles';

import {
  createMuiTheme,
} from '@material-ui/core/styles';

import Project from './components/Callout';

// const headlineFont = 'CNN Condensed,CNN,Helvetica Neue,Helvetica,Arial,Utkal,sans-serif';
const bodyFont = 'CNN,Helvetica Neue,Helvetica,Arial,Utkal,sans-serif';

const theme = createMuiTheme({
  palette: {
    primary: { main: 'rgb(38, 38, 38)' },
    secondary: { main: 'rgb(115, 115, 115)' },
  },
  typography: {
    fontFamily: bodyFont,
    h1: {
      fontSize: 26,
      fontWeight: 'bold',
      '@media (min-width: 600px)': {
        fontSize: 24,
      },
    },
    body1: {
      fontSize: 14,
      lineHeight: 1.57,
      color: 'rgb(38, 38, 38)',
    },
    subtitle2: {
      fontSize: 12,
      fontWeight: 'normal',
      color: 'rgb(140, 140, 140)',
      '& a': {
        color: '#262626',
        textDecoration: 'none',
        '&:hover': {
          textDecoration: 'underline',
          color: '#0C0C0C',
        },
      },
    },
  },
  button: {
    boxShadow: 'none',
    textTransform: 'capitalize',
    borderRadius: 4,
    fontSize: 14,
    width: 100,
    height: 40,
  },
});

const jss = create({...jssPreset()});

const generateClassName = createGenerateClassName({
  productionPrefix: 'cnnix-callout',
});

const Expire = () => null;

const App = () => (
  <StylesProvider jss={jss} generateClassName={generateClassName}>
    <ThemeProvider theme={ theme }>
      <Project />
    </ThemeProvider>
  </StylesProvider>
);

const badExpirationDate = !expirationDate.getTime();
const now = new Date();
const isExpired = now > expirationDate;

const id = 'graphic';
const node = document.getElementById(id);

if (isExpired || badExpirationDate) {
  // hide interactive
  console.warn('Callout form has expired');
  render(<Expire />, node);

} else {
  //  start Interactive
  render(<App />, node);
}


